module.exports = __webpack_public_path__ + "static/media/travelDemand.ea7c5810.png";